import { render, staticRenderFns } from "./agreements.vue?vue&type=template&id=fbbac01c&scoped=true"
import script from "./agreements.vue?vue&type=script&lang=js"
export * from "./agreements.vue?vue&type=script&lang=js"
import style0 from "./agreements.vue?vue&type=style&index=0&id=fbbac01c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbac01c",
  null
  
)

export default component.exports